module.exports = __webpack_public_path__ + "static/media/padrao.af51b7c8.png";